export let routes = [
  {
    path: '/x3-side-course',
    name: 'x3-side-course',
    component: () => import('@x3/js/side/course/course.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-course-price',
    name: 'x3-side-course-price',
    component: () => import('@x3/js/side/course/course-price.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-course-price-type',
    name: 'x3-side-course-price-type',
    component: () => import('@x3/js/side/course/course-price-type.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-course-filtrate',
    name: 'x3-side-course-filtrate',
    component: () => import('@x3/js/side/course/filtrate/course-new-filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-course-dimension',
    name: 'x3-side-course-dimension',
    component: () => import('@x3/js/side/course/filtrate/dimension.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsCourse(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-course',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCoursePrice(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-course-price',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCoursePriceType(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-course-price-type',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCourseFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-course-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCourseDimension(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-course-dimension',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
